import { render, staticRenderFns } from "./UserPermissionsCard.vue?vue&type=template&id=218ebfe5"
import script from "./UserPermissionsCard.vue?vue&type=script&lang=js"
export * from "./UserPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserProfileComponents/UserPermissionsCard.vue
// module id = 790
// module chunks = 31